import { useState } from 'react';
import StarRating from 'react-rating-stars-component';
import { ButtonPopup } from '../../../ui';
import { CommentFormProps } from '@/types';

// 🟢 Variable de entorno para la URL del backend
import { safeFetch } from '@/api/safeFetch';


const CommentForm: React.FC<CommentFormProps> = ({ perfil_id, nombre_usuario, onCommentAdded, onClose }) => {
  const [comentario, setComentario] = useState<string>('');
  const [puntuacion, setPuntuacion] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);
  // ⭐ Manejo de la puntuación con estrellas
/*   const handleStarClick = (nextValue: number) => {
    setPuntuacion(nextValue);
  }; */

  // 📨 Enviar comentario
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      // 🟢 Llamada a la API usando variable de entorno
      const response = await safeFetch(`/api/addComentario`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          perfil_id,
          nombre_usuario,
          comentario,
          puntuacion,
        }),
      });

      if (!response.ok) {
        throw new Error('Error al enviar el comentario');
      }

      onCommentAdded(); // 🔄 Refresca comentarios
      window.location.reload(); // ⚠️ Se mantiene reload como en original
      onClose?.();
    } catch (error: unknown) {
      setError((error as Error).message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md">
        <h2 className="text-2xl text-zinc-900 mb-4">Añadir un Comentario</h2>

        {error && <p className="dark:text-red-500">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="comentario" className="block text-sm dark:text-zinc-900 font-semibold mb-2">Comentario:</label>
            <textarea
              id="comentario"
              className="w-full p-2 border-zinc-700 border rounded data:text-zinc-100 bg-white"
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm text-zinc-900 font-semibold mb-2">Puntuación:</label>
            <StarRating
              count={5}
              value={puntuacion}
              onChange={(newValue: number) => setPuntuacion(newValue)}
              size={30}
              activeColor="#facc15"
              
            />

          </div>

          <div className="flex justify-end space-x-4">
            <ButtonPopup type="button" className="hover:border-red-600" onClick={onClose}>Cancelar</ButtonPopup>
            <ButtonPopup type="submit">Enviar</ButtonPopup>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CommentForm;
